(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCategoryCarousel(root) {
      var track = root.querySelector('[data-carousel-track]');
      var prevBtn = root.querySelector('[data-carousel-prev]');
      var nextBtn = root.querySelector('[data-carousel-next]');
      if (!track || !prevBtn || !nextBtn) return;

      var autoplay = root.dataset.autoplay === 'true';
      var autoplaySpeed = (parseFloat(root.dataset.autoplaySpeed) || 4) * 1000;
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var timer = null;

      function slideAmount() {
        var slide = track.querySelector('.category-carousel__slide');
        if (!slide) return track.clientWidth;
        var style = window.getComputedStyle(track);
        var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
        return slide.getBoundingClientRect().width + gap;
      }

      function updateArrows() {
        var maxScroll = track.scrollWidth - track.clientWidth - 1;
        prevBtn.disabled = track.scrollLeft <= 0;
        nextBtn.disabled = track.scrollLeft >= maxScroll && maxScroll > 0;
        if (maxScroll <= 0) {
          prevBtn.disabled = true;
          nextBtn.disabled = true;
        }
      }

      function scrollByAmount(direction) {
        track.scrollBy({ left: direction * slideAmount(), behavior: 'smooth' });
      }

      function advanceAutoplay() {
        var maxScroll = track.scrollWidth - track.clientWidth - 1;
        if (track.scrollLeft >= maxScroll) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          scrollByAmount(1);
        }
      }

      function startAutoplay() {
        if (!autoplay || reducedMotion || timer) return;
        timer = window.setInterval(advanceAutoplay, autoplaySpeed);
      }

      function stopAutoplay() {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      }

      prevBtn.addEventListener('click', function () {
        scrollByAmount(-1);
      });

      nextBtn.addEventListener('click', function () {
        scrollByAmount(1);
      });

      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(updateArrows);
      });

      root.addEventListener('mouseenter', stopAutoplay);
      root.addEventListener('mouseleave', startAutoplay);
      root.addEventListener('touchstart', stopAutoplay, { passive: true });
      root.addEventListener('touchend', function () {
        window.setTimeout(startAutoplay, 2000);
      });
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          stopAutoplay();
        } else {
          startAutoplay();
        }
      });

      window.addEventListener('resize', updateArrows);

      updateArrows();
      startAutoplay();
    }

    document.querySelectorAll('[data-category-carousel]').forEach(initCategoryCarousel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTestimonialsCarousel(root) {
      var track = root.querySelector('[data-carousel-track]');
      var prevBtn = root.querySelector('[data-carousel-prev]');
      var nextBtn = root.querySelector('[data-carousel-next]');
      if (!track || !prevBtn || !nextBtn) return;

      var autoplay = root.dataset.autoplay === 'true';
      var autoplaySpeed = (parseFloat(root.dataset.autoplaySpeed) || 5) * 1000;
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var timer = null;

      function slideAmount() {
        var slide = track.querySelector('.testimonials-carousel__slide');
        if (!slide) return track.clientWidth;
        var style = window.getComputedStyle(track);
        var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
        return slide.getBoundingClientRect().width + gap;
      }

      function updateArrows() {
        var maxScroll = track.scrollWidth - track.clientWidth - 1;
        prevBtn.disabled = track.scrollLeft <= 0;
        nextBtn.disabled = track.scrollLeft >= maxScroll && maxScroll > 0;
        if (maxScroll <= 0) {
          prevBtn.disabled = true;
          nextBtn.disabled = true;
        }
      }

      function scrollByAmount(direction) {
        track.scrollBy({ left: direction * slideAmount(), behavior: 'smooth' });
      }

      function advanceAutoplay() {
        var maxScroll = track.scrollWidth - track.clientWidth - 1;
        if (track.scrollLeft >= maxScroll) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          scrollByAmount(1);
        }
      }

      function startAutoplay() {
        if (!autoplay || reducedMotion || timer) return;
        timer = window.setInterval(advanceAutoplay, autoplaySpeed);
      }

      function stopAutoplay() {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      }

      prevBtn.addEventListener('click', function () {
        scrollByAmount(-1);
      });

      nextBtn.addEventListener('click', function () {
        scrollByAmount(1);
      });

      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(updateArrows);
      });

      root.addEventListener('mouseenter', stopAutoplay);
      root.addEventListener('mouseleave', startAutoplay);
      root.addEventListener('touchstart', stopAutoplay, { passive: true });
      root.addEventListener('touchend', function () {
        window.setTimeout(startAutoplay, 2000);
      });
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          stopAutoplay();
        } else {
          startAutoplay();
        }
      });

      window.addEventListener('resize', updateArrows);

      updateArrows();
      startAutoplay();
    }

    document.querySelectorAll('[data-testimonials-carousel]').forEach(initTestimonialsCarousel);
  })();

  } catch(e) { console.error(e); }
})();
})();
